import styled from 'styled-components';

const DateTileList = styled.div`
    display: flex;
`;

export default DateTileList;
